<template>
  <div class="station-titlebar" :style="{'background-color': stageColour, 'color': titleColour}">
    {{stageName}} - {{stationName}}
    <div class="station-titlebar-time">{{currentTime}}</div>
    <button class="station-titlebar-refresh" @click.prevent="refreshClicked"><i class="far fa-sync"></i></button>
  </div>
</template>

<style lang="scss" scoped>

.station-titlebar {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 0 0 10px;
  
  line-height: 30px;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #404040;
  text-transform: uppercase;
}
.station-titlebar-time {
  position: absolute;
  top: 9px;
  right: 28px;
  font-size: 12px;
  line-height: 12px;
  vertical-align: top;
  padding: 0;
  margin: 0;
  text-transform: none;
}
.station-titlebar-refresh {
  cursor: pointer;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 2px;
  width: 24px;
  font-size: 12px;
  line-height: 12px;
  vertical-align: top;
  padding: 0;
  margin: 0;
  text-transform: none;
  color: inherit;
  border: none;
  background-color: transparent;
}
</style>

<script>
import moment from 'moment'
import colourMixin from '@/mixins/colour'

export default {
  name: 'StationTitleBar',
  mixins: [colourMixin],
  props: {
    stageName: String,
    stationName: String,
    stageColour: {
      type: String,
      default: '#3F88C9'
    }
  },
  data() {
    return {
      currentTime: ''
    }
  },
  computed: {
    titleColour() {
      return this.textColourForBackground(this.stageColour)
    }
  },
  mounted () {
    this.updateDateTime()
    this.$options.interval = setInterval(this.updateDateTime, 1000)
  },
  beforeDestroy () {
    clearInterval(this.$options.interval);
  },
  methods: {
    updateDateTime() {
      this.currentTime = moment().local().format('H:mm a')
    },
    refreshClicked() {
      // Just refresh the browser
      window.location.reload()
    }
  }
  
}
</script>